import { Component, OnInit } from '@angular/core';
import { LoadingController, AlertController } from '@ionic/angular';
import { ApiserviceService } from '../../../../app/httpservice/apiservice.service';

@Component({
  selector: 'app-role-management-data',
  templateUrl: './role-management-data.component.html',
  styleUrls: ['./role-management-data.component.scss'],
})
export class RoleManagementDataComponent implements OnInit {

  roleManagementData: any = [];

  constructor(
    public loadingController: LoadingController,
    public alertCtrl: AlertController,
    public apiService: ApiserviceService
  ) { }

  ngOnInit() { }

  async ionViewDidEnter() {
    await this.getRoleManagement();
  }

  async getRoleManagement() {


    await this.apiService._post(this.apiService.apiUrl + this.apiService.getRoleManagement, {}).then(res => {
      console.log('[getRoleManagement] response : ', res);

      if(res.statusCode === 200) {
        this.roleManagementData = res.data;
      }else{
        this.ErrorMsg(res.statusMessage);
      }

    })
  }

  async manualAlert(msg: string) {
    let alert = await this.alertCtrl.create({
      subHeader: msg,
    });
    await alert.present();
    setTimeout(() => {
      alert.dismiss(true);
    }, 2000);

  }

  async updateRoleManagement() {
    console.log('[updateRoleManagement] roleManagementData : ', this.roleManagementData);

    await this.apiService._post(this.apiService.apiUrl + this.apiService.setRoleManagement, this.roleManagementData).then(async res => {
      console.log('[updateRoleManagement] response : ', res);
      await this.manualAlert('บันทึกข้อมูลสำเร็จ');
      await this.getRoleManagement();
    })

  }

  changeRemark(value: string, indx: number) {
    this.roleManagementData[indx].remark = value;
  }

  async ErrorMsg(message: string) {
    let alert = await this.alertCtrl.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }

}
